// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2nBIR","additionalInfo":"AgreementModal_additionalInfo__JDLjQ"};